import { render, staticRenderFns } from "./QuestionnaireStep3Cpt.vue?vue&type=template&id=56eea96e&"
import script from "./QuestionnaireStep3Cpt.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireStep3Cpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports